module.exports = __webpack_public_path__ + "img/banner-title.9a2dfe7e.png";